/**
 * Tiny window-event bus so any surface (account menu, footer, a "need help?"
 * link in copy) can pop the support widget open without prop-drilling through
 * the app shell. The widget subscribes via {@link onOpenSupport}.
 */
const OPEN_EVENT = "bb:open-support";

/** Open the floating support widget from anywhere in the app. */
export function openSupport(): void {
  window.dispatchEvent(new CustomEvent(OPEN_EVENT));
}

/** Subscribe to open requests. Returns an unsubscribe fn. */
export function onOpenSupport(handler: () => void): () => void {
  const listener = () => handler();
  window.addEventListener(OPEN_EVENT, listener);
  return () => window.removeEventListener(OPEN_EVENT, listener);
}
